// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2FZW8","image":"Header_image__1WJQy","name":"Header_name__3IvKp","info":"Header_info__3ey_T","infoRow":"Header_infoRow__1hQej"};